import * as React from "react"

export const SearchIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.017 12.68q-1.948 0-3.314-1.367Q3.338 9.948 3.337 8q0-1.947 1.366-3.313T8.016 3.32t3.314 1.366T12.696 8a4.6 4.6 0 0 1-.269 1.563 5 5 0 0 1-.726 1.346l4.586 4.587q.174.173.177.372.004.2-.177.381a.54.54 0 0 1-.387.181.54.54 0 0 1-.387-.181l-4.586-4.566a5 5 0 0 1-1.371.735q-.745.26-1.54.26m0-1.084q1.506 0 2.55-1.045Q11.614 9.507 11.614 8t-1.045-2.551-2.552-1.045q-1.506 0-2.551 1.045T4.42 8t1.045 2.551 2.551 1.045"
    ></path>
  </svg>
)
